export const DefaultFormValue = {
  user_id: null,
  logo: {
    url: '',
    raw: '',
    filename: ''
  },
  image_1: {
    url: '',
    raw: '',
    filename: ''
  },
  image_2: {
    url: '',
    raw: '',
    filename: ''
  },
}